import React from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import DatePicker from "react-datepicker";
import moment from 'moment';
import "react-datepicker/dist/react-datepicker.css";
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import {
    FormGroup,
    Label,
} from 'reactstrap';
import {
    ResponsiveContainer,
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
} from "recharts";
import ChartConfig, { tooltipStyle, tooltipTextStyle } from 'Constants/chart-config';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';

import {
    addBDFivePoints,
    fetchPuttDistance,
    stdBDFivePoints,
} from 'Actions';

import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

class PointItems extends React.Component {

    static propTypes = {
        classes: PropTypes.object,
        prev: 0,
    };

    constructor(props) {

        super(props);
        this.tableEnd = React.createRef();
        this.state = {
            startdate: this.props.data.startdate,
            enddate: this.props.data.enddate,
            student: this.props.data.student,
            loader: false,
            sepmore: this.props.data.sepmore,
            formValues: this.props.data.formValues,
            linedata: this.props.data.linedata,
            pointchart: true,
            linemax: this.props.data.linemax,
            totavgpoints: this.props.data.totavgpoints,
        };

        this.chartValue = this.chartValue.bind(this);

    }

    UNSAFE_componentWillMount() {

        this.scrollToBottom();
    }


    scrollToBottom = () => {
        console.log('rrr');
        this.tableEnd.current?.scrollIntoView({ behavior: "smooth" });
    }

    addHandleSubmit(event) {
        event.preventDefault();
        this.setState({ loader: true });
        var sepmore = this.state.sepmore;
        var student = this.state.student;
        var start = this.state.startdate;
        var end = this.state.enddate;
        this.props.addBDFivePoints(student, start, end, event, sepmore).then((data) => {

            this.setState({
                loader: false
            });

        });

    }

    filterDateSubmit() {
        var student = this.state.student;
        var stdate = moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate = moment(new Date(this.state.enddate)).format('yyyy-MM-DD');

        this.setState({
            loader: true,
        });

        this.props.stdBDFivePoints(student, stdate, eddate).then((data) => {
            var resdata = data.data;
            var alldata = [];
            var highval = [];
            var st = 0;
            if (resdata.length != 0) {

                {
                    resdata.map((teamval, idx) => (


                        alldata.push({
                            x: idx + 1,
                            y: teamval.gpb_points,
                        }),
                        highval[idx] = teamval.gpb_points,
                        st = st + teamval.gpb_points

                    ))
                }
                var totavg = parseFloat((st / resdata.length).toFixed(2));

                const maxNumber = Math.max(...highval) + 10;
                this.setState({

                    linedata: [...alldata],
                    linemax: maxNumber
                });
            } else {
                this.setState({
                    linedata: [],
                    linemax: 20,
                });
            }

            this.setState({
                loader: false,
            });

        });

    }

    selectstart = (date) => {
        this.setState({ startdate: date });
    }

    selectend = (date) => {
        this.setState({ enddate: date });
    }

    addFormFields() {
        var chktotal = this.state.sepmore;
        var totalsep = chktotal + 1;
        this.setState(({
            sepmore: totalsep,
            formValues: [...this.state.formValues, { puttdate: "", noputt: "" }]
        }))
    }

    removeFormFields(i) {
        let formValues = this.state.formValues;
        var chktotal = this.state.sepmore;
        var totalsep = chktotal - 1;
        formValues.splice(i, 1);
        this.setState({ formValues, sepmore: totalsep });
        this.chartValue(totalsep);
    }

    handleChange(i, e, frm) {
        let formValues = this.state.formValues;

        if (frm == 1) {
            formValues[i]['puttdate'] = e;
            this.setState({ formValues });
        } else {
            formValues[i][e.target.name] = e.target.value;
            this.setState({ formValues });

        }

        if (frm == 2) {
            this.chartValue(i + 1);
        }

    }

    chartValue(total) {

        this.setState({ pointchart: false });
        let formValues = this.state.formValues;
        var alldata = [];
        var highval = [];
        var st = 0;
        for (let d = 0; d < total; d++) {
            var puttval = formValues[d]['noputt'];
            var start = d;
            var xval = start + 1;
            alldata[d] = { x: xval, y: puttval };
            highval[d] = puttval;
            if (puttval != "") {
                st = parseFloat(st) + parseFloat(puttval);
            }
        }

        var totavg = parseFloat((st / total).toFixed(2));
        const maxNumber = Math.max(...highval) + 10;
        this.setState({ linedata: [...alldata], linemax: maxNumber, totavgpoints: totavg });
        this.setState({ pointchart: true });
    }

    handleNumberic(e) {
        if (!/[0-9,.,-]/.test(e.key)) {
            e.preventDefault();
        }
    }


    render() {

        const { studentlists, loading } = this.props;
        const allstudent = studentlists.map((stdval) => {
            return {
                label: stdval.student,
                value: stdval.uudID
            }
        });

        return (
            <div>
                <div className="col-lg-12">
                    <form autoComplete="off" id="addform" onSubmit={(e) => this.addHandleSubmit(e)}>
                        <div className="row">
                            <div className="col-sm-12 col-lg-12" style={{ margin: "0 auto" }}>
                                <RctCollapsibleCard heading="5FT BROADIE DRILL - POINTS SYSTEM">
                                    <div className="col-sm-12 col-lg-12"><h5 style={{ color: "blue" }}>How many points did you get in 10 putts?</h5></div>
                                    <div className="row">

                                        <div className="col-sm-12 col-lg-5 clearfix">
                                            <div className="table-responsive" style={{ height: "300px" }}>
                                                <Table>
                                                    <TableHead style={{ position: "sticky", top: "0" }}>
                                                        <TableRow hover>
                                                            <TableCell style={{ position: "sticky", top: "0" }} align="center" width={'10%'}>NO.</TableCell>
                                                            <TableCell style={{ position: "sticky", top: "0" }} align="center" width={'20%'}>DATE</TableCell>
                                                            <TableCell style={{ position: "sticky", top: "0" }} align="center" width={'30%'}>POINTS AFTER 10 PUTTS </TableCell>
                                                            <TableCell style={{ position: "sticky", top: "0" }} align="center" width={'10%'}>DELETE</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>

                                                        {this.state.formValues.map((element, i) => (

                                                            <TableRow key={i}>
                                                                <TableCell>{i + 1}</TableCell>
                                                                <TableCell>
                                                                    <DatePicker className="form-control form-control-alternative" name={'puttdate'} id={'puttdate_' + i} required autoComplete="off"
                                                                        selected={element.puttdate}
                                                                        onChange={e => this.handleChange(i, e, 1)}
                                                                        dateFormat='yyyy-MM-dd'
                                                                        peekNextMonth
                                                                        showMonthDropdown
                                                                        showYearDropdown
                                                                    />
                                                                </TableCell>
                                                                <TableCell><input type="text" name={'noputt'} id={'noputt_' + i} value={element.noputt || ""} onKeyPress={e => this.handleNumberic(e)} onChange={e => this.handleChange(i, e, 2)} className="form-control form-control-alternative" required /></TableCell>
                                                                <TableCell>
                                                               
                                                                            <IconButton style={{ width: "10px", height: "10px" }} className="text-danger" aria-label="Remove" onClick={() => this.removeFormFields(i)}  > <DeleteOutlineOutlinedIcon/></IconButton>
                                                                           
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </div>

                                            <div className="col-lg-12" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div style={{ flex: '0 0 auto', width: '20%' }}>
                                                    <span style={{ color: "red" }}><strong>PGA, AVG - 16</strong></span>
                                                </div>
                                                <div style={{ flex: '0 0 auto', width: '50%' }}>
                                                    <Table>
                                                        <TableBody>
                                                            <TableRow>
                                                                <TableCell></TableCell>
                                                                <TableCell><strong>AVG Points</strong></TableCell>
                                                                <TableCell><input type="text" name={'totalavg'} value={this.state.totavgpoints} className="form-control form-control-alternative" readOnly /></TableCell>
                                                            </TableRow>
                                                        </TableBody>
                                                    </Table>
                                                </div>
                                                <div style={{ flex: '0 0 auto', width: '20%' }}>
                                                    <button className="mr-3 mb-3 btn btn-outline-primary btn-sm float-right" type="button" onClick={() => this.addFormFields()}> <i className="zmdi zmdi-plus-circle-o"></i> add shot</button>
                                                </div>
                                            </div>
                                        </div>
                                        {this.state.pointchart &&
                                            <div className="col-sm-12 col-lg-7 clearfix">
                                                <div className="row" style={{ marginTop: "-50px" }}>
                                                    <div className="col-sm-12 col-lg-4 clearfix"></div>
                                                    <div className="col-sm-12 col-lg-3 clearfix">
                                                        <FormGroup >
                                                            <DatePicker className="form-control" id="startdate" placeholderText="Start Date" name="startdate" autoComplete="off"
                                                                selected={this.state.startdate}
                                                                onChange={this.selectstart}
                                                                dateFormat='yyyy-MM-dd'
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    <div className="col-sm-12 col-lg-3 clearfix">
                                                        <FormGroup >
                                                            <DatePicker className="form-control" id="enddate" placeholderText="End Date" name="enddate" autoComplete="off"
                                                                selected={this.state.enddate}
                                                                onChange={this.selectend}
                                                                dateFormat='yyyy-MM-dd'
                                                                peekNextMonth
                                                                showMonthDropdown
                                                                showYearDropdown
                                                            />
                                                        </FormGroup>
                                                    </div>
                                                    <div className="form-group clearfix">
                                                        <button className="mr-3 mb-3 btn btn-outline-warning" type="button" onClick={() => this.filterDateSubmit()}>Filter</button>

                                                    </div>
                                                </div>
                                                <ResponsiveContainer width='100%' height={300}>
                                                    <LineChart data={this.state.linedata}>
                                                        <XAxis dataKey="x" domain={[0, "auto"]} stroke={ChartConfig.axesColor} />
                                                        <YAxis stroke={ChartConfig.axesColor} domain={[0, this.state.linemax]} />
                                                        <CartesianGrid vertical={false} stroke={ChartConfig.chartGridColor} />
                                                        <Tooltip wrapperStyle={tooltipStyle} cursor={false} itemStyle={tooltipTextStyle} labelStyle={{ display: 'none' }} />

                                                        <Line type="bumpX" dataKey="y" stroke={'#FF7F50'} label={{ fill: '#757474', fontSize: 15, position: 'top' }} dot={{ strokeWidth: 4 }} activeDot={{ r: 10 }} />
                                                    </LineChart>
                                                </ResponsiveContainer>
                                            </div>
                                        }
                                        <div className="col-lg-12 clearfix">
                                            <div className="form-group">
                                                <button type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" disabled={this.state.loader}>Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </RctCollapsibleCard>
                            </div>
                        </div>
                    </form>
                </div>
                {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                }
            </div>

        )

    }

}

const mapStateToProps = ({ mostlyused }) => {
    const { studentlists, loading } = mostlyused;
    return { studentlists, loading };

}


export default connect(mapStateToProps, {
    addBDFivePoints,
    fetchPuttDistance,
    stdBDFivePoints,
})(PointItems);
